import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import { css, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Button } from '@openx/components-core/lib/Button/Button';
import type { ReactNode } from 'react';

export const StyledBackButton = styled(Button)`
  margin: ${({ theme }) => theme.spacing(0, 1)};
`;

export const StyledDivider = styled(Divider)`
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

export const StyledHeaderContainerDiv = styled('div', {
  shouldForwardProp: prop => prop !== 'sticky' && prop !== 'hasSubtitle',
})<{
  sticky?: boolean;
  hasSubtitle?: boolean;
}>`
  background: ${({ theme }) => theme.palette.secondary.main};
  color: ${({ theme }) => theme.palette.common.white};
  display: flex;
  padding: ${({ theme }) => theme.spacing(3, 4)};
  padding-top: ${({ theme }) => theme.spacing(3.5)};
  height: var(--header-height);
  -webkit-box-orient: vertical;

  ${({ hasSubtitle }) =>
    hasSubtitle &&
    css`
      height: auto;
      min-height: var(--header-height);
    `}

  position: ${props => (props.sticky ? 'sticky' : 'static')};
  top: ${props => (props.sticky ? 0 : 'auto')};
  z-index: ${props => (props.sticky ? 1001 : 'auto')};
`;

export const StyledTitleTypography = styled(Typography)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 30px;
  overflow-wrap: anywhere;
`;

export const StyledSubtitleTypography = styled(Typography)`
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledTitleBadgeTypography = styled(Typography)`
  font-weight: 600;
  font-size: 10px;
  text-transform: uppercase;
  white-space: nowrap;
  margin-left: ${({ theme }) => theme.spacing(1.3)};
  margin-top: ${({ theme }) => theme.spacing(-0.7)};
`;

export const StyledTitleContainerGrid = styled(Grid)`
  height: 75%;
  min-width: 0;
`;

export const StyledContentContainerDiv = styled('div')<{ hasChildren?: ReactNode }>`
  ${({ hasChildren, theme }) =>
    Boolean(hasChildren) &&
    css`
      background-color: ${theme.palette.common.white};
      border-bottom: 1px solid ${theme.palette.background.grayLight};
      display: flex;
      flex-direction: column;
      flex-grow: 1;

      & > form {
        height: 100%;
      }
    `}
`;
